import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f746bf4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "tw-flex tw-justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Filter Journey", -1))
const _hoisted_4 = { class: "control" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = { class: "control" }
const _hoisted_7 = { class: "section" }
const _hoisted_8 = { class: "content has-text-grey has-text-centered" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "There's no data to show", -1))


import NewPagination from "../../Modules/Breakdown/NewPagination.vue";
import TaxonomyLevel from "../../Modules/JourneyPaths/TaxonomyLevel.vue";
import AdditionalInformation from "../../Modules/JourneyPaths/AdditionalInformation.vue";
import TouchpointSearch from "../../Modules/JourneyPaths/TouchpointSearch.vue";
import ModalTemplate from "../../Modules/Pieces/ModalTemplate.vue";
import ExportData from "../../Modules/Pieces/ExportData.vue";

import JourneyPathModalSearchItem from "../../Modules/JourneyPaths/JourneyPathModalSearchItem.vue";

const __default__ = {
  title: "Journey Paths",
  components: {
    TouchpointSearch,
    TaxonomyLevel,
    AdditionalInformation,
    NewPagination,
    ExportData,
    ModalTemplate,
    JourneyPathModalSearchItem,
  },
};
import { storeToRefs } from "pinia";
import {
  assign,
  uniq,
  map,
  mapValues,
  groupBy,
  isEmpty,
  unset,
  filter,
  get,
  cloneDeep,
} from "lodash";
import axios from "axios";
import moment from "moment";
import { computed, onMounted, ref, watch } from "vue";
import { UseDateStore } from "../../Modules/State/Stores/DateStore";
import { UseMainStore } from "../../Modules/State/SingleViewStorePinia";
import { UseProgramStore } from "../../Modules/State/Stores/ProgramStore";
import { UseNumberHelper } from "../../Helper/Functional/UseNumberHelper";
import { UseAxiosErrorHelper } from "../../Helper/ThirdParty/UseAxiosErrorHelper";
import { UseStringHelper } from "../../Helper/Functional/UseStringHelper";
import { UseBadgeHelper } from "../../Helper/Functional/UseBadgeHelper";
import { UseUrlBuilder } from "../../Helper/Stateful/UseUrlBuilder";

import {
  TConfigurationObject,
  TLevelObject,
  IJourneyDataFullResponse,
  IJourneyProcessedData,
  TCrunchedData,
  IJourneyPath,
  TJourneyPathAllData,
} from "./Typings/JourneyPathTypes";
type TSolidTLevelObject<T> = Record<keyof T, Exclude<T[keyof T], undefined>>;


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { getDateFrom, getDateTo } = storeToRefs(UseDateStore());
const { getApiBaseUrl } = storeToRefs(UseMainStore());
const { getCurrentProgram, getCurrentProgramName } = storeToRefs(UseProgramStore());
const { validateApiParameter } = UseStringHelper();
const { displayMonetaryValue, displayNumericValueOneDp } = UseNumberHelper();
const { basicURlBuilder: taxonomiesUrl } = UseUrlBuilder({
  dataSet: "",
});
const { getTagType } = UseBadgeHelper();

//Middleware
UseAxiosErrorHelper();

//Configuration
const configuration = ref<TConfigurationObject>({
  anywhere_connector: "or",
} as TConfigurationObject);

const fixConfiguration = (taxData: TSolidTLevelObject<TLevelObject>[]) => {
  let exists = function (v: TLevelObject) {
    return !isEmpty(filter(taxData, v));
  };

  let rtn: TConfigurationObject = cloneDeep(configuration.value);

  rtn.first = filter(rtn.first, exists);
  rtn.last = filter(rtn.last, exists);
  rtn.anywhere = filter(rtn.anywhere, exists);
  rtn.comparison = filter(
    map(rtn.comparison, function (v) {
      v.before = exists(v.before!) ? v.before : {};
      v.after = exists(v.before!) ? v.after : {};

      return v;
    }),
    (v) => !isEmpty(v.before) && !isEmpty(v.after)
  );

  configuration.value = rtn;
};

const page = ref(1);
const perPage = ref(160);
const modalActive = ref(false);
const taxonomyLevel = ref(2);
const additionalInformation = ref("none");
const searchTerm = ref(null);

//Url building

const appendStr = computed(() => {
  let mapped = {} as TConfigurationObject;

  let mapper = function (v: TLevelObject) {
    let rtn = {} as TLevelObject,
      t1 = get(v, "taxonomy_1", null),
      t2 = get(v, "taxonomy_2", null),
      t3 = get(v, "taxonomy_3", null),
      t4 = get(v, "taxonomy_4", null);

    if (t1) assign(rtn, { taxonomy_one: t1 });
    if (t2) assign(rtn, { taxonomy_two: t2 });
    if (t3) assign(rtn, { taxonomy_three: t3 });
    if (t4) assign(rtn, { taxonomy_four: t4 });

    return rtn;
  };

  // First
  mapped.first = filter(map(configuration.value.first, mapper), (v) => !isEmpty(v));
  if (!mapped.first.length) unset(mapped, "first");
  // Last
  mapped.last = filter(map(configuration.value.last, mapper), (v) => !isEmpty(v));
  if (!mapped.last.length) unset(mapped, "last");
  // Anywhere
  mapped.anywhere = filter(map(configuration.value.anywhere, mapper), (v) => !isEmpty(v));
  mapped.anywhere_connector = configuration.value.anywhere_connector;
  if (!mapped.anywhere.length) {
    unset(mapped, "anywhere");
    unset(mapped, "anywhere_connector");
  }
  // Comparison
  mapped.comparison = filter(
    map(cloneDeep(configuration.value.comparison), function (v) {
      v.before = mapper(v.before!);
      v.after = mapper(v.after!);

      return v;
    }),
    (v) => !isEmpty(v.before) && !isEmpty(v.after)
  );
  if (!mapped.comparison.length) unset(mapped, "comparison");

  let str = "";
  if (!isEmpty(mapped)) {
    str = "&journey_search=" + validateApiParameter(JSON.stringify(mapped));
  }

  return decodeURI(str);
});

const journeysUrl = computed(() => {
  return (
    getApiBaseUrl.value +
    "/programs/" +
    getCurrentProgram.value +
    "/performance/touchpoints/journeys?" +
    "date_from=" +
    getDateFrom.value +
    "&date_to=" +
    getDateTo.value +
    "&sort_by=" +
    sortMetric.value +
    "&sort_direction=" +
    sortMetricDirection.value +
    "&page=" +
    page.value +
    "&per_page=" +
    perPage.value +
    appendStr.value +
    journeysSearchUrl.value
  );
});

const journeysSearchUrl = computed(() => {
  if (!searchTerm.value) return "";
  return "&order_id=" + searchTerm.value;
});

//Loading
const taxonomiesLoading = ref(false);
const journeysLoading = ref(false);
const loading = computed(() => taxonomiesLoading.value || journeysLoading.value);
const allowedToLoadJourney = ref(false);

//Data
const taxonomiesData = ref([] as TSolidTLevelObject<TLevelObject>[]);
const journeysData = ref({} as IJourneyDataFullResponse);
const headers = ref<string[]>([]);
const columnHeaders = ref({
  order_id: "Order ID",
  conversion_date: "Conversion",
  unique_four: "Unique Touches",
  journey_export: "Journey Paths",
  journey_length: "Journey Length",
});
const loadAvailableTaxonomies = () => {
  taxonomiesLoading.value = true;

  axios
    .get<{ data: TSolidTLevelObject<TLevelObject>[] }>(taxonomiesUrl.value)
    .then(({ data }) => {
      fixConfiguration(data.data);
      taxonomiesData.value = data.data;

      taxonomiesLoading.value = false;
      allowedToLoadJourney.value = true;
    })
    .catch(() => {
      taxonomiesLoading.value = false;
    });
};

const loadJourneyData = () => {
  journeysLoading.value = true;
  axios
    .get<{ data: IJourneyDataFullResponse }>(journeysUrl.value)
    .then(({ data }) => {
      journeysData.value = data.data;
      journeysLoading.value = false;
    })
    .catch(() => {
      journeysLoading.value = false;
    });
};

const passAllTaxonomyDataParsed = computed(
  (): TJourneyPathAllData => {
    return mapValues(groupBy(taxonomiesData.value, "taxonomy_1"), (a) =>
      mapValues(groupBy(a, "taxonomy_2"), (b) =>
        mapValues(groupBy(b, "taxonomy_3"), (c) => map(c, "taxonomy_4"))
      )
    ) as TJourneyPathAllData;
  }
);

//Static Modal Data

const modalData = computed(() => [
  {
    configKey: "first",
    twoDepth: false,
    twoDepthKeys: [],
    twoDepthLabelImmediately: "",
    title: "Journeys starting with",
    subtitle: "Any touch-points added here will be treated as 'and'",
    buttonText: "Add 'starting with'",
    icons: [],
    nativeValues: [],
  },
  {
    configKey: "last",
    twoDepth: false,
    twoDepthKeys: [],
    twoDepthLabelImmediately: "",
    title: "Journeys ending with",
    subtitle: "Any touch-points added here will be treated as 'and'",
    buttonText: "Add 'ending with'",
    icons: [],
    nativeValues: [],
  },
  {
    configKey: "anywhere",
    twoDepth: false,
    twoDepthKeys: [],
    twoDepthLabelImmediately: "",
    title: "Journeys that include touch-points",
    subtitle: "Any touch-points added here will be treated as undefined",
    buttonText: "Add 'include'",
    icons: ["transit-detour", "transit-connection-variant"],
    nativeValues: ["Or", "And"],
  },
  {
    configKey: "comparison",
    twoDepth: true,
    twoDepthKeys: ["before", "after"],
    twoDepthLabelImmediately: "Immediately before / after",
    title: "Touch-point comparison",
    subtitle: "Any touch-points added here will be treated as 'and'",
    buttonText: "Add 'comparison'",
    icons: [],
    nativeValues: [],
  },
]);

//Table Data
const sortMetric = ref("conversion_date");
const sortMetricDirection = ref("desc");
const taxStrArray = ["taxonomy_1", "taxonomy_2", "taxonomy_3", "taxonomy_4"] as const;
let count = 0;
let nextNames = "";

/**
 *
 * @param path of type IJourneyPath
 * @param keys tuple taxStrArray
 * @param index number to index tuple
 * @returns value at path's index of tuple surrounded by parentheses.
 */
const nameBuilder = <
  T extends IJourneyPath,
  U extends typeof taxStrArray,
  V extends number
>(
  path: T,
  keys: U,
  index: V
) => ` (${path[keys[index]]})`;

/**
 * Recursive function to return concatenated string of journey paths
 * @param jp of type IJourneyPath
 * @param keys tuple taxStrArray
 * @param limit number to define count length
 * @param gate boolean determined by nextExists for nextName or just false if getting the taxonomy name
 * @param nextPath optional parameter to get the nextName, is off type IJourneyPath
 * @returns {string} name of path
 */
const nextNameExistHandler = <T extends IJourneyPath, U extends typeof taxStrArray>(
  jp: T,
  keys: U,
  limit: number,
  gate: boolean,
  nextPath?: T
): string => {
  let returnNextName = "";
  let tempNextPath = jp;
  if (gate && nextPath) {
    tempNextPath = nextPath;
  }
  if (tempNextPath[keys[count]] === "None") {
    returnNextName = nextNames;
    nextNames = "";
    count = 0;
    return returnNextName;
  }
  //NextT1
  if (count === 0) {
    nextNames += tempNextPath[keys[count]];
    count++;
    return nextNameExistHandler(jp, keys, limitReducer(limit), gate, nextPath);
  }

  if (count <= limit) {
    nextNames += nameBuilder(tempNextPath, keys, count);
    count++;
    return nextNameExistHandler(jp, keys, limitReducer(limit), gate, nextPath);
  }
  returnNextName = nextNames;
  count = 0;
  nextNames = "";
  return returnNextName;
};

/**
 * Intermediary function to return array of T1, nextT1, T2, nextT2, T3, nextT3, T4, nextT4 values
 * @param limit number to define array length
 * @param path of type IJourneyPath
 * @param gate boolean determined by nextExists for nextName or just false if getting the taxonomy name
 * @param nextPath optional parameter to get the nextName, is off type IJourneyPath
 */
const nameExtractionHandler = <T extends IJourneyPath>(
  limit: number,
  path: T,
  gate: boolean,
  nextPath: T
) => {
  const returnArray: string[] = [];
  const loop = Array.from(Array(limit).keys());
  loop.forEach((pos) => {
    pos++;
    returnArray.push(
      nextNameExistHandler(path, taxStrArray, pos, false),
      nextNameExistHandler(path, taxStrArray, pos, gate, nextPath)
    );
  });
  return returnArray;
};

/**
 *
 * @param counts Array of numbers
 * @param crunchedDataList Array of objects containing taxonomy value, next taxonomy value and the crunchedData
 * @param exists boolean
 * @returns Array of objects containing the changed count and crunchedData array. The crunchedData will have a count which represents how many times it was used. If the nextExists boolean is true and the names are the same for both taxonomies then it keeps on increasing the amount but if not it saves it into the array and resets the count to 1
 */
const crunchedDataHandler = (
  counts: number[],
  crunchedDataList: {
    tax: string;
    nextTax: string;
    crunchedData: TCrunchedData[];
  }[],
  shapley_credit: number,
  order_amount: number,
  exists: boolean
) => {
  return crunchedDataList.map((dl, i) => {
    if (exists && dl.tax === dl.nextTax) {
      counts[i]++;
    } else {
      dl.crunchedData.push({
        name: dl.tax,
        count: counts[i],
        proportionalCredit: `${displayNumericValueOneDp(
          shapley_credit * 100
        )}%`,
        revenue: displayMonetaryValue(shapley_credit * order_amount),
      });
      counts[i] = 1;
    }
    return {
      count: counts[i],
      crunchedData: dl.crunchedData,
    };
  });
};

/**
 * To avoid SonarCloud kicking off about reducing limit in the recursive function call
 * @param limit number to be reduced by 1
 * @returns number
 */
const limitReducer = (limit: number) => limit--;

const processedData = computed((): IJourneyProcessedData[] => {
  if (journeysData.value && journeysData.value.data) {
    (journeysData.value.data as IJourneyProcessedData[]).forEach((jd) => {
      let crunchedTwo = [] as TCrunchedData[],
        crunchedThree = [] as TCrunchedData[],
        crunchedFour = [] as TCrunchedData[],
        countTwo = 1,
        countThree = 1,
        countFour = 1;

      let total_shapley = 0;

      jd.journey_path.forEach((jp, i) => {
        const nextExists = jd.journey_path[i + 1]
          ? Object.keys(jd.journey_path[i + 1]).length > 0
          : false;
        const next = jd.journey_path[i + 1];
        total_shapley += jp.shapley_credit;

        const [t2, nextT2, t3, nextT3, t4, nextT4] = nameExtractionHandler(
          4,
          jp,
          nextExists,
          next
        );

        const [taxTwo, taxThree, taxFour] = crunchedDataHandler(
          [countTwo, countThree, countFour],
          [
            { tax: t2, nextTax: nextT2, crunchedData: crunchedTwo },
            { tax: t3, nextTax: nextT3, crunchedData: crunchedThree },
            { tax: t4, nextTax: nextT4, crunchedData: crunchedFour },
          ],
          total_shapley,
          jd.order_amount,
          nextExists
        );

        if (
          (taxonomyLevel.value === 2 && t2 !== nextT2) ||
          (taxonomyLevel.value === 3 && t3 !== nextT3) ||
          (taxonomyLevel.value === 4 && t4 !== nextT4)
        ) {
          total_shapley = 0;
        }

        countTwo = taxTwo.count;
        crunchedTwo = taxTwo.crunchedData;
        countThree = taxThree.count;
        crunchedThree = taxThree.crunchedData;
        countFour = taxFour.count;
        crunchedFour = taxFour.crunchedData;

        assign(jd, { journey_length: jd.journey_path.length });
        assign(jd, { crunched_two: crunchedTwo });
        assign(jd, { unique_two: uniq(jd.crunched_two).length });
        assign(jd, { crunched_three: crunchedThree });
        assign(jd, { unique_three: uniq(jd.crunched_three).length });
        assign(jd, { crunched_four: crunchedFour });
        assign(jd, { unique_four: uniq(jd.crunched_four).length });
        assign(jd, {
          journey_touches: uniq(map(jd.journey_path, (v) => Object.keys(v)[0])),
        });
      });
    });
    return journeysData.value.data as IJourneyProcessedData[];
  }
  return [];
});

const exportData = computed(() => {
  const dataForExport: IJourneyProcessedData[] = [];

  processedData.value.forEach((d) => {
    if (taxonomyLevel.value === 2) {
      d.journey_export = d.crunched_two.map((c) => exportPathValue(c)).join(", ");
    } else if (taxonomyLevel.value === 3) {
      d.journey_export = d.crunched_three.map((c) => exportPathValue(c)).join(", ");
    } else {
      d.journey_export = d.crunched_four.map((c) => exportPathValue(c)).join(", ");
    }

    dataForExport.push(d);
  });

  return dataForExport;
});

const exportPathValue = (crunchedData: TCrunchedData) => {
  if (additionalInformation.value === "none" && crunchedData.count > 1) {
    return `${crunchedData.name} - x${crunchedData.count}`;
  } else if (additionalInformation.value === "proportionalCredit") {
    return `${crunchedData.name} - ${crunchedData.proportionalCredit}`;
  } else if (additionalInformation.value === "attributedRevenue") {
    return `${crunchedData.name} - ${crunchedData.revenue}`;
  }

  return crunchedData.name;
};

const onSort = (field: string, order: string) => {
  sortMetric.value = field;
  sortMetricDirection.value = order;
};

const formatConversionDate = (date: Date | string) => {
  return moment(date).format("MMMM Do YYYY, hh:mm").replace(/ /g, "\u00a0");
};

const getTagText = (crunchedData: TCrunchedData) => {
  if (additionalInformation.value === "none" && crunchedData.count > 1) {
    return `x${crunchedData.count}`;
  } else if (additionalInformation.value === "proportionalCredit") {
    return crunchedData.proportionalCredit;
  } else if (additionalInformation.value === "attributedRevenue") {
    return crunchedData.revenue;
  }

  return null;
};

//Side Effects

onMounted(() => {
  loadAvailableTaxonomies();
});
watch(taxonomiesUrl, () => {
  loadAvailableTaxonomies();
});
watch(journeysUrl, () => {
  if (allowedToLoadJourney.value) {
    loadJourneyData();
  }
});
watch(allowedToLoadJourney, () => {
  loadJourneyData();
});

return (_ctx: any,_cache: any) => {
  const _component_o_loading = _resolveComponent("o-loading")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_table_column = _resolveComponent("o-table-column")!
  const _component_sv_badge = _resolveComponent("sv-badge")!
  const _component_o_table = _resolveComponent("o-table")!
  const _component_outer_section = _resolveComponent("outer-section")!

  return (_openBlock(), _createBlock(_component_outer_section, null, {
    default: _withCtx(() => [
      _createVNode(_component_o_loading, {
        "full-page": true,
        active: _unref(loading),
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null))
      }, null, 8, ["active"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(NewPagination, {
            records: journeysData.value.total,
            page: page.value,
            "onUpdate:page": _cache[1] || (_cache[1] = ($event: any) => ((page).value = $event)),
            "per-page": perPage.value,
            "onUpdate:per-page": _cache[2] || (_cache[2] = ($event: any) => ((perPage).value = $event)),
            perPageOptions: [15, 30, 50, 10000]
          }, null, 8, ["records", "page", "per-page"]),
          _createVNode(_component_o_field, null, {
            default: _withCtx(() => [
              _createVNode(_component_o_input, {
                placeholder: "Search for Order ID...",
                type: "search",
                icon: "magnify",
                modelValue: searchTerm.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchTerm).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_o_field, {
          grouped: "",
          "group-multiline": ""
        }, {
          default: _withCtx(() => [
            _createVNode(AdditionalInformation, {
              "additional-information": additionalInformation.value,
              "onUpdate:additional-information": _cache[4] || (_cache[4] = ($event: any) => ((additionalInformation).value = $event))
            }, null, 8, ["additional-information"]),
            _createVNode(TaxonomyLevel, {
              "taxonomy-level": taxonomyLevel.value,
              "onUpdate:taxonomy-level": _cache[5] || (_cache[5] = ($event: any) => ((taxonomyLevel).value = $event))
            }, null, 8, ["taxonomy-level"]),
            _createElementVNode("button", {
              class: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (modalActive.value = true))
            }, [
              _createVNode(_component_o_icon, { icon: "filter-outline" }),
              _hoisted_3
            ]),
            _createVNode(ExportData, {
              "available-columns": Object.keys(columnHeaders.value),
              "selected-columns": Object.keys(columnHeaders.value),
              "column-headers": columnHeaders.value,
              "report-name": `${_unref(getCurrentProgramName)}_journey-paths_${_unref(getDateFrom)}_${_unref(getDateTo)}`,
              "exportable-data": _unref(exportData),
              "order-data-by": sortMetric.value,
              "order-data-direction": sortMetricDirection.value
            }, null, 8, ["available-columns", "selected-columns", "column-headers", "report-name", "exportable-data", "order-data-by", "order-data-direction"])
          ]),
          _: 1
        }),
        _createVNode(ModalTemplate, {
          modalActive: modalActive.value,
          "onUpdate:modalActive": _cache[9] || (_cache[9] = ($event: any) => ((modalActive).value = $event)),
          title: "Journey Path Filter"
        }, {
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modalData), (modData) => {
              return (_openBlock(), _createBlock(JourneyPathModalSearchItem, {
                key: modData.configKey + modData.title,
                data: configuration.value,
                "onUpdate:data": _cache[7] || (_cache[7] = ($event: any) => ((configuration).value = $event)),
                "static-props": modData,
                "all-taxonomies-data": _unref(passAllTaxonomyDataParsed),
                onUpdateAnywhere: _cache[8] || (_cache[8] = (v) => (configuration.value.anywhere_connector = v))
              }, null, 8, ["data", "static-props", "all-taxonomies-data"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modalActive"]),
        _createVNode(_component_o_table, {
          ref: "journeyPathsBackendTable",
          narrowed: "",
          hoverable: "",
          data: _unref(processedData),
          "backend-sorting": "",
          "backend-filtering": "",
          "default-sort": [sortMetric.value, sortMetricDirection.value],
          onSort: onSort
        }, {
          empty: _withCtx(() => [
            _createElementVNode("section", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (!_unref(loading))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("p", null, [
                        _createVNode(_component_o_icon, {
                          icon: "emoticon-sad",
                          size: "is-large"
                        })
                      ]),
                      _hoisted_9
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_o_table_column, {
              field: "order_id",
              label: headers.value['order_id'] || 'Order',
              sortable: ""
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.row.order_id), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_o_table_column, {
              field: "conversion_date",
              label: headers.value['conversion_date'] || 'Conversion',
              sortable: ""
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString(formatConversionDate(props.row.conversion_date)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_o_table_column, {
              field: "journey_path",
              label: "Journey",
              sortable: ""
            }, {
              default: _withCtx((props) => [
                _createVNode(_component_o_field, {
                  grouped: "",
                  "group-multiline": ""
                }, {
                  default: _withCtx(() => [
                    (taxonomyLevel.value === 2)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.row.crunched_two, (item) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("ul", {
                              class: _normalizeClass({ 'tw-flex': item.count > 1 })
                            }, [
                              _createVNode(_component_sv_badge, {
                                color: _unref(getTagType)(item.name),
                                addonText: getTagText(item)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["color", "addonText"])
                            ], 2)
                          ]))
                        }), 256))
                      : _createCommentVNode("", true),
                    (taxonomyLevel.value === 3)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(props.row.crunched_three, (item) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("ul", {
                              class: _normalizeClass({ 'tw-flex': item.count > 1 })
                            }, [
                              _createVNode(_component_sv_badge, {
                                color: _unref(getTagType)(item.name),
                                addonText: getTagText(item)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["color", "addonText"])
                            ], 2)
                          ]))
                        }), 256))
                      : _createCommentVNode("", true),
                    (taxonomyLevel.value === 4)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(props.row.crunched_four, (item) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("ul", {
                              class: _normalizeClass({ 'tw-flex': item.count > 1 })
                            }, [
                              _createVNode(_component_sv_badge, {
                                color: _unref(getTagType)(item.name),
                                addonText: getTagText(item)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["color", "addonText"])
                            ], 2)
                          ]))
                        }), 256))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_component_o_table_column, {
              field: "journey_length",
              label: "Journey Length",
              sortable: "",
              centered: ""
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.row.journey_length), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_o_table_column, {
              field: 
            taxonomyLevel.value === 2
              ? 'unique_two'
              : taxonomyLevel.value === 3
              ? 'unique_three'
              : 'unique_four'
          ,
              label: "Unique Touches",
              centered: ""
            }, {
              default: _withCtx((props) => [
                (taxonomyLevel.value === 2)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(props.row.unique_two), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (taxonomyLevel.value === 3)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(props.row.unique_three), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (taxonomyLevel.value === 4)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(props.row.unique_four), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["field"])
          ]),
          _: 1
        }, 8, ["data", "default-sort"])
      ])
    ]),
    _: 1
  }))
}
}

})